import React from 'react';
import { Quote } from 'lucide-react';
interface TestimonialCardProps {
  quote: string;
  author: string;
  position: string;
}
export default function TestimonialCard({
  quote,
  author,
  position
}: TestimonialCardProps) {
  return <div className="bg-white rounded-lg shadow-md p-6 h-full flex flex-col" data-id="element-311">
      <div className="text-secondary mb-4" data-id="element-312">
        <Quote className="h-8 w-8" data-id="element-313" />
      </div>
      <p className="text-slate-dark italic mb-6 flex-grow" data-id="element-314">{quote}</p>
      <div data-id="element-315">
        <p className="font-bold text-primary" data-id="element-316">{author}</p>
        <p className="text-slate text-sm" data-id="element-317">{position}</p>
      </div>
    </div>;
}